// src/app/core/services/notification.service.ts

import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  private defaultConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  success(message: string, title?: string): void {
    const fullMessage = title ? `${title}: ${message}` : message;
    this.snackBar.open(fullMessage, 'Close', {
      ...this.defaultConfig,
      panelClass: ['snack-success']
    });
  }

  error(message: string, title?: string): void {
    const fullMessage = title ? `${title}: ${message}` : message;
    this.snackBar.open(fullMessage, 'Close', {
      ...this.defaultConfig,
      panelClass: ['snack-error'],
      duration: 5000 // Errors show longer
    });
  }

  warning(message: string, title?: string): void {
    const fullMessage = title ? `${title}: ${message}` : message;
    this.snackBar.open(fullMessage, 'Close', {
      ...this.defaultConfig,
      panelClass: ['snack-warning']
    });
  }

  info(message: string, title?: string): void {
    const fullMessage = title ? `${title}: ${message}` : message;
    this.snackBar.open(fullMessage, 'Close', {
      ...this.defaultConfig,
      panelClass: ['snack-info']
    });
  }
}

// Add these styles to your global styles.scss:
/*
.snack-success {
  .mdc-snackbar__surface {
    background-color: #4caf50 !important;
  }
}

.snack-error {
  .mdc-snackbar__surface {
    background-color: #f44336 !important;
  }
}

.snack-warning {
  .mdc-snackbar__surface {
    background-color: #ff9800 !important;
  }
}

.snack-info {
  .mdc-snackbar__surface {
    background-color: #2196f3 !important;
  }
}
*/
